import { toolItems } from '../../../mocks/toolItems';

const categoryColors: Record<string, string> = {
  'Power Tools': 'text-red-400 border-red-400/30 bg-red-400/10',
  'Hand Tools': 'text-[#f5a623] border-[#f5a623]/30 bg-[#f5a623]/10',
  'Diagnostics': 'text-green-400 border-green-400/30 bg-green-400/10',
  'Specialty': 'text-purple-400 border-purple-400/30 bg-purple-400/10',
  'Electrical': 'text-cyan-400 border-cyan-400/30 bg-cyan-400/10',
};

const ToolBench = () => (
  <section id="tool-bench" className="w-full bg-[#161616] py-24 relative overflow-hidden">
    {/* Subtle tool silhouette pattern background */}
    <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
      backgroundImage: 'repeating-linear-gradient(45deg, #f5a623 0, #f5a623 1px, transparent 0, transparent 50%)',
      backgroundSize: '20px 20px',
    }} />

    <div className="relative z-10 max-w-7xl mx-auto px-6">
      {/* Section Header */}
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-4">
        <div className="flex items-center gap-4">
          <div className="w-1 h-8 bg-[#f5a623] rounded-full" />
          <div>
            <p className="text-[#f5a623] text-xs font-['Roboto'] font-bold tracking-[4px] uppercase mb-1">
              Affiliate Links
            </p>
            <h2 className="font-['Bebas_Neue'] text-5xl text-white tracking-wider flex items-center gap-3">
              THE TOOL BENCH
              <div className="w-8 h-8 flex items-center justify-center text-[#f5a623]">
                <i className="ri-tools-fill text-3xl" />
              </div>
            </h2>
          </div>
        </div>
      </div>

      <p className="text-[#9a9a9a] text-sm font-['Roboto'] italic mb-12 ml-5">
        Gear I actually use (and trust). Nothing here because someone paid me — just the tools that show up on camera.
      </p>

      {/* Tools Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {toolItems.map((tool) => (
          <div
            key={tool.id}
            className="group bg-[#1f1f1f] rounded-xl overflow-hidden border border-[#2a2a2a] hover:border-[#f5a623]/40 transition-all duration-300 flex gap-4 p-5"
          >
            {/* Tool Image */}
            <div className="w-20 h-20 rounded-lg overflow-hidden flex-shrink-0 bg-[#2a2a2a]">
              <img
                src={tool.imageUrl}
                alt={tool.name}
                title={`${tool.name} – Beer After Work Tool Bench`}
                className="w-full h-full object-top object-cover"
              />
            </div>

            {/* Info */}
            <div className="flex-1 flex flex-col gap-2 min-w-0">
              {/* Category Badge */}
              <span className={`self-start text-xs font-['Roboto'] font-bold px-2 py-0.5 rounded border tracking-[1px] whitespace-nowrap ${categoryColors[tool.category] || 'text-[#f5a623] border-[#f5a623]/30 bg-[#f5a623]/10'}`}>
                {tool.category}
              </span>

              <h3 className="text-white font-['Roboto'] font-bold text-sm leading-snug">{tool.name}</h3>
              <p className="text-[#6a6a6a] text-xs font-['Roboto'] leading-relaxed">{tool.description}</p>

              {/* Rating & Link */}
              <div className="flex items-center justify-between mt-auto pt-2">
                <div className="flex items-center gap-0.5">
                  {[1, 2, 3, 4, 5].map((s) => (
                    <div key={s} className="w-3 h-3 flex items-center justify-center">
                      <i className={`ri-star-fill text-xs ${s <= tool.rating ? 'text-[#f5a623]' : 'text-[#333333]'}`} />
                    </div>
                  ))}
                </div>
                <a
                  href={tool.affiliateUrl}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="flex items-center gap-1 text-[#f5a623] hover:text-white text-xs font-['Roboto'] font-bold transition-colors cursor-pointer whitespace-nowrap"
                >
                  Check Price
                  <div className="w-3 h-3 flex items-center justify-center group-hover:translate-x-0.5 transition-transform">
                    <i className="ri-arrow-right-line text-xs" />
                  </div>
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Affiliate Disclosure */}
      <p className="mt-8 text-[#444444] text-xs font-['Roboto'] text-center">
        * Affiliate links — I may earn a small commission if you buy. Costs you nothing extra, helps keep the lights on in the garage.
      </p>
    </div>
  </section>
);

export default ToolBench;
